namespace $ {
	export let $hyoo_sync_masters = [
		`sync.hyoo.ru`,
		`sync-pmzz.onrender.com`,
	]
}
